// Static config to avoid recreating arrays/objects on each render
export const GOOGLE_MAPS_LIBRARIES = ["places"];
export const API_SERVER ="https://api.vyango.com";